module.exports = __webpack_public_path__ + "img/Rogue-undead-f-70.7b814acc.gif";